import { useState, useEffect } from 'react';
import { getSecureCookie, setSecureCookie } from '@/utils/secureCookies';

const CSRF_TOKEN_NAME = 'csrf-token';

export const useCSRFProtection = () => {
  const [csrfToken, setCsrfToken] = useState<string | null>(null);

  useEffect(() => {
    // Get existing token or generate new one
    let token = getSecureCookie(CSRF_TOKEN_NAME);
    
    if (!token) {
      // Generate a random token
      token = btoa(crypto.getRandomValues(new Uint8Array(32)).toString());
      setSecureCookie(CSRF_TOKEN_NAME, token, {
        httpOnly: false, // Need to access from JS
        secure: true,
        sameSite: 'strict',
        maxAge: 60 * 60 // 1 hour
      });
    }
    
    setCsrfToken(token);
  }, []);

  const getCSRFHeaders = () => ({
    'X-CSRF-Token': csrfToken || '',
  });

  const validateCSRFToken = (submittedToken: string): boolean => {
    return submittedToken === csrfToken && csrfToken !== null;
  };

  return {
    csrfToken,
    getCSRFHeaders,
    validateCSRFToken
  };
};